module.exports = __webpack_public_path__ + "static/NW_KP_Bild_Lands_1_a-7540535a7ae553937f9697ca4cd52802.jpg";